module.exports = __webpack_public_path__ + "static/img/7.b7e29af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carruDepto/7.jpg
// module id = k9T6
// module chunks = 5